export const TransacMode = {
    ENROLL: "ENROLL",
    VERIFY: "VERIFY",
    CAPTURE: "CAPTURE"
}

export const Base64 = {
    DEFAULT: 0,
    NO_PADDING: 1,
    NO_WRAP: 2,
    CRLF: 4,
    URL_SAFE: 8,
    NO_CLOSE: 16
}

export const HandType = {
    LEFT: "LEFT",
    RIGHT: "RIGHT"
}